import { TkRequiredText } from "../../components/atoms/TkRequiredText";
import { Typography } from "@mui/material";

const infoManual1 = `直近3ヶ月の退職者に対して、雇用保険資格喪失証明書等の登録をしてください。`;

const infoHeadTitleList: any[] = [
  {
    headTitle: (
      <>
        <Typography>施設名称</Typography>
      </>
    ),
  },
  {
    headTitle: (
      <>
        <Typography>退職者</Typography>
      </>
    ),
  },
  {
    headTitle: (
      <>
        <Typography>生年月日</Typography>
      </>
    ),
  },
  {
    headTitle: (
      <>
        <Typography>退職日</Typography>
      </>
    ),
    className: "SCRC050107TableButtonClomun",
  },
  {
    headTitle: (
      <>
        <Typography>
          「雇用保険資格喪失証明書」等の登録
          <TkRequiredText lineBreak={false} />
        </Typography>
      </>
    ),
  },
];

export { infoManual1, infoHeadTitleList };
